import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';
import { MarginRtoDatesStore } from './margin-rto-dates.store';
import { MarginRtoDate } from '../../models/margin-rto-date.model';

@Injectable({ providedIn: 'root' })
export class MarginRtoDatesReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginRtoDatesStore = inject(MarginRtoDatesStore);
    private readonly destroy$ = inject(DestroyRef);

    constructor() {
        this.listenToLoadMarginDetailsEvent();
        this.listenToRtoDateAddedEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                const rtoDates = event.payload.marginDetails?.marginRtoDates || [];
                this.marginRtoDatesStore.updateRtoDatesFromData(rtoDates);
            });
    }

    private listenToRtoDateAddedEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.RTO_DATES_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                const selectedDates = event.payload.rtoDates as Date[];
                const marginId = event.payload.marginId as number;

                // Convert the array of dates to MarginRtoDate objects
                const rtoDates: MarginRtoDate[] = selectedDates.map((date) => ({
                    marginId,
                    rtoDate: date
                }));

                // Update the store with the new RTO dates
                this.marginRtoDatesStore.updateRtoDatesFromData(rtoDates);
            });
    }
}
